// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.yO8u7Foo6VI4rlqh {
	width: 750px;
}

.UbLSIoNlTYE0INd9 {
	border: 1px solid var(--lok-color-border-default);
}
`, "",{"version":3,"sources":["webpack://./packages/rag/src/components/OverrideStep/OverrideStep.module.css"],"names":[],"mappings":"AAAA;CACC,YAAY;AACb;;AAEA;CACC,iDAAiD;AAClD","sourcesContent":[".container {\n\twidth: 750px;\n}\n\n.table {\n\tborder: 1px solid var(--lok-color-border-default);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `yO8u7Foo6VI4rlqh`,
	"table": `UbLSIoNlTYE0INd9`
};
export default ___CSS_LOADER_EXPORT___;
